import React from 'react'
// Mobile components
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { SignIn } from './mobile/signin'
import { LoggedRoute, ProtectRoutes } from './context/AuthContext'
import { Callback } from './components/signin/callback'
import { CreateWorkspace } from './mobile/workspace/create'
import { Dashboard } from './mobile/dashboard'
import { DashboardContextProvider } from './context/DashboardContext'
import { WorkspaceProvider } from './context/WorkspaceContext'

export function MobileApp() {
  return (
    <Routes>
      <Route path="/callback" element={<Callback />} />
      <Route
        path="/signin"
        element={
          <LoggedRoute>
            <SignIn />
          </LoggedRoute>
        }
      />
      <Route
        path="/workspace"
        element={
          <ProtectRoutes>
            <Outlet />
          </ProtectRoutes>
        }
      >
        <Route path="" element={<Navigate to="create" />} />
        <Route path="create" element={<CreateWorkspace />} />
      </Route>
      <Route path="/dashboard" element={<Navigate to="/dashboard/home-new" />} />
      <Route
        path="/dashboard/:selectedMenu/:roadmapMenu?"
        element={
          <ProtectRoutes>
            <WorkspaceProvider>
              <DashboardContextProvider>
                <Dashboard />
              </DashboardContextProvider>
            </WorkspaceProvider>
          </ProtectRoutes>
        }
      />
      <Route path="*" element={<Navigate to="/signin" />} />
    </Routes>
  )
}
